import React, { useState, useEffect } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import api from "../../seller-apis/api";
import "./support.css";
import { useDispatch } from "react-redux";
import { Actions } from "../../Actions/Actions";
import { useRef } from "react";
import { uploadImage } from "../../utilities/imageUpload";
import { isImageOrVideo } from "../../utilities/checkFileType";
import { uploadVideo } from "../../utilities/videoUpload";
import { useAlert } from "react-alert";
import moment from "moment";



function Message({ type, content, time, from, images, videos, modalFun, mediaRemoved, docs }) {
  // sl-687
  const styles = {
    messageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: type === 'sent' ? 'flex-end' : 'flex-start',
      marginBottom: '15px',
    },
    messageBubble: {
      position: 'relative',
      maxWidth: '60%',
      padding: '12px 18px',
      borderRadius: '20px',
      fontSize: '14px',
      lineHeight: '1.5',
      wordWrap: 'break-word',
      marginBottom: '5px',
      display: 'inline-block',
      backgroundColor: type === 'sent' ? '#dcf8c6' : '#fff', // Background color
      border: type === 'received' ? '1px solid #ece5dd' : 'none', // Border for received messages
      alignSelf: type === 'sent' ? 'flex-end' : 'flex-start', // Alignment
      wordBreak: 'break-word',
      boxShadow: type === 'sent' ? '0px 2px 4px rgba(0, 0, 0, 0.1)' : 'none', // Optional shadow for sent messages
    },
    messageContent: {
      marginBottom: '10px',
    },
    timestamp: {
      fontSize: '12px',
      color: '#999',
      margin: '5px 0px',
      alignSelf: 'center',
    },
    mediaSupport: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    mediaItem: {
      position: 'relative',
      width: '300px',
      height: 'auto',
      marginBottom: '5px',
    },
    attachmentImage: {
      width: '100%',
      height: '100%',
      borderRadius: '10px',
      objectFit: 'contain',
    },
    playOverlay: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      padding: '10px',
      borderRadius: '50%',
    },
    playIcon: {
      color: 'white',
      fontSize: '24px',
    },
    sentMessageBubble: {
      backgroundColor: 'whitesmoke',
      alignSelf: 'flex-end',
      borderTopRightRadius: '4px',
    },
    receivedMessageBubble: {
      backgroundColor: '#c5d6d6',
      border: '1px solid #ece5dd',
      alignSelf: 'flex-start',
      borderTopLeftRadius: '0px',
    },
    errorText: {
      color: '#999',
      fontStyle: 'italic',
      textAlign: 'center',
      padding: '10px',
    },
    pdf: {
      fontSize: '100px',
      borderBottom: "1px solid black"
    }
  };

  // sl-687
  const [imageErrors, setImageErrors] = useState({});
  const [videoErrors, setVideoErrors] = useState({});

  // Fallback handler for images
  const handleImageError = (index) => {
    setImageErrors((prevErrors) => ({
      ...prevErrors,
      [index]: true,
    }));
  };

  // Fallback handler for videos
  const handleVideoError = (index) => {
    setVideoErrors((prevErrors) => ({
      ...prevErrors,
      [index]: true,
    }));
  };
  const formatedDate = (time) => {
    const date = new Date(time);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1.
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = String(hours % 12 || 12).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;

  }

  return (

    <div style={styles.messageContainer}>
      {/* Timestamp */}
      <span style={styles.timestamp}>
        {formatedDate(time)}
      </span>
      <div style={{
        ...styles.messageBubble,
        ...(type === 'sent' ? styles.sentMessageBubble : styles.receivedMessageBubble),
      }}>
        {/* Message Content (Text) */}
        <span style={styles.messageContent}>{content}</span>

        {/* sl-687 */}
        {/* Media (Images and Videos) */}
        {mediaRemoved ? <span style={styles.errorText}>Attachment Not Available</span> :

          <div style={{ ...styles.mediaSupport, marginTop: (images?.length > 0 || videos?.length > 0) ? "10px" : "0px" }}>
            {/* Images */}
            {images?.map((item, index) => (
              <div
                key={index}
                style={styles.mediaItem}
              >
                {imageErrors[index] ? (
                  <span style={styles.errorText}>Attachment Not Available</span>
                ) : (
                  <img
                    src={item}
                    alt="image"
                    style={styles.attachmentImage}
                    onClick={() => modalFun(item, 'image', true)}
                    onError={() => handleImageError(index)} // On error show fallback message
                  />
                )}
              </div>
            ))}

            {/* Videos */}
            {videos?.map((item, index) => (
              <div
                key={index}
                style={styles.mediaItem}
              >
                {videoErrors[index] ? (
                  <span style={styles.errorText}>Attachment Not Available</span>
                ) : (
                  <>
                    <iframe
                      src={`https://iframe.videodelivery.net/${item}`}
                      style={styles.attachmentImage}
                      onError={() => handleVideoError(index)}
                      allow="autoplay; fullscreen"
                    >
                    </iframe>
                  </>
                )}

              </div>
            ))}

            {/* Docs */}
            {docs?.map((item, index) => (
              <div
                key={index}
                style={styles.mediaItem}
              >
                <a href={'https://s3.toolsvilla.com/' + item} target="_blank" rel="noopener noreferrer">
                  <span style={styles.pdf}><i className="bi bi-file-earmark-pdf"></i></span>
                </a>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

const SupportMessageModal = ({
  show,
  handleClose,
  handleConfirm,
  ticket,
  flag,
}) => {

  const styles = {
    modal: {
      zoom: {
        body: {
          "background": "white",
          "borderRadius": "8px",
          "padding": "20px",
          "position": "relative",
          "width": "900px",
          "height": "80vh",
          "maxWidth": "90%",
          "borderRadius": "15px",
        },
        img: {
          "width": "100%",
          "height": "100%",
          // "objectFit": "contain",
          "padding": "6px"
        },
        video: {
          "width": "100%",
          "height": "100%",
          // "objectFit": "contain",
          "padding": "6px"
        }
      },
      close: {
        "position": "absolute",
        "top": "0px",
        "right": "0px",
      }
    },
    text: {
      sizeInfo: {
        fontSize: "11px",

      }
    }
  }

  const alert = useAlert()
  const [messages, setmessages] = useState([]);
  const [msgText, setMsgText] = useState("");
  const [uploading, setIsUploading] = useState(false);
  // media modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");

  const dispatch = useDispatch();
  const myDivRef = useRef(null);

  const scrollToBottom = () => {
    myDivRef.current.scrollTop = myDivRef.current.scrollHeight;
  };
  useEffect(() => {
    show && getMessage();
    ticket?.adminMsgInfo?.vendorViewed == false && updateReadMsg();
    show && scrollToBottom();
    if (ticket?.remarks?.[0]?.new_msg === true && ticket?.remarks?.[0]?.from === "admin") {
      markMessagesAsRead();
    }
  }, [show]);

  const markMessagesAsRead = async () => {
    try {
      const body = {
        sellerSupportReqId: ticket._id,
        from: "vendor",
      };
      await api.supportTicket.readSellerSupportMessage(body);
    } catch (error) {
      console.error('Error marking messages as read:', error);
    }
  };

  const getSupportMsgNotificationCount = () => {
    let fromDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
    let toDate = moment().format('YYYY-MM-DD');
    let param = {
      "pageNo": 1, "size": 1,
      "filter": {
        "adminMsgInfo.vendorViewed": false,
        "from-createdAt": fromDate + 'T00:00:00.000Z',
        "to-createdAt": toDate + 'T23:59:59.000Z'
      },
      "sortFilter": { "createdAt": -1 }
    }
    api.supportTicket.getSupportTicket(param).then((ticket) => {
      Actions.updateSellerCount(dispatch, ticket.totalRecords);
    });
  }
  const updateReadMsg = () => {
    let param = {
      "_id": ticket._id, "adminMsgInfo.vendorViewed": true
    };
    api.supportTicket
      .updateReadMessage(param)
      .then((res) => {
        getSupportMsgNotificationCount();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getMessage = () => {
    if (flag === "SellerSupportMsg") {
      let data = {
        pageNo: 1,
        size: 100,
        filter: {
          sellerSupportReqId: ticket?._id,
        },
        sortFilter: { _id: 1 },
      }
      api.supportTicket
        .getSellerSupportMessages(data)
        .then((res) => {
          console.log("res", res);
          setmessages(res.data);
          scrollToBottom();
        })
        .catch((err) => {
          console.log(err);
        });

    } else {
      let filter = {
        pageNo: 1,
        size: 100,
        filter: {
          freshSupportId: ticket._id,
        },
        sortFilter: { createdAt: 1 },
      };
      api.supportTicket
        .getSupportMessages(filter)
        .then((res) => {
          setmessages(res.data);
          scrollToBottom();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  const saveMessage = (isFile = false, imgUrls = null, vidUrls = null, fileType = null) => {

    if (!msgText.trim() && fileType === null) {
      console.log("Message cannot be empty or spaces only.");
      return;
    }
    else {
      setMsgText(fileType);
    }

    if (flag === "SellerSupportMsg") {
      let data = {
        sellerSupportReqId: ticket?._id,
        vendorName: ticket?.vendor_name,
        from: "vendor",
        msg: msgText,
        new_msg: true
      }
      api.supportTicket
        .saveSellerSupportMessage(data)
        .then((messages) => {
          console.log(messages);
          if (ticket?.remarks?.[0]?.new_msg === true) {
            const body = {
              sellerSupportReqId: ticket?._id,
              from: "vendor",
            }
            api.supportTicket.readSellerSupportMessage(body)
              .then((res) => {
                console.log("res******", res);
              })
              .catch((err) => {
                console.log("err", err);
              })
          }
          setMsgText("");
          getMessage();
        })
        .catch((err) => {
          console.log(err);
        });
    }
    else {
      let filter = {
        vendorDetails: { vendorName: localStorage.getItem("name"), _id: localStorage.getItem("vendorId") },
        adminName: ticket?.agent && ticket?.agent.length > 0 ? ticket.agent[ticket.agent.length - 1].contact.name : ticket?.agent?.contact?.name,
        opened: true,
        from: "vendor",
        images: imgUrls !== null && fileType === "attachment" ? imgUrls : [],
        msg: msgText ? msgText : fileType,
        freshSupportId: ticket._id,
        videos: vidUrls !== null && fileType === "attachment" ? vidUrls : [],
      };
      api.supportTicket
        .saveSupportMessages(filter)
        .then((messages) => {
          console.log(messages);
          setMsgText("");
          getMessage();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleFileChange = async (event) => {
    try {
      const files = event.target.files;
      const vendorId = localStorage.getItem("vendorId");

      const images = Array.from(files).filter((file) => isImageOrVideo(file) === "image");
      const videos = Array.from(files).filter((file) => isImageOrVideo(file) === "video");


      if (images.length < 1 && videos.length < 1) {
        throw new Error("Please upload a valid image or video.Only images and video supported.")
      }

      if (images.length > 3) {
        throw new Error("You can upload a maximum of 3 images.");
      }
      if (videos.length > 1) {
        throw new Error("You can upload a maximum of 1 video.");
      }

      setIsUploading(true);

      const imageUploads = images.map((file) => uploadImage(file, vendorId));

      const videoUploads = videos.length > 0 ? [uploadVideo(videos[0], vendorId)] : [];

      const uploadResults = await Promise.all([...imageUploads, ...videoUploads]);

      let imagesUrl = [];
      let videosUrl = [];
      uploadResults.forEach((res) => {
        if (res.msg === "success") {
          imagesUrl = res.fileType === "image" ? [...imagesUrl, res.url] : imagesUrl;
          videosUrl = res.fileType === "video" ? [...videosUrl, res.url] : videosUrl;
        } else {
          throw new Error("Upload failed");
        }
      });
      if (videosUrl.length > 0) {
        alert.info("Please note that video preview takes around 1-2 mins even after it is uploaded successfully.")
      }
      saveMessage(true, imagesUrl, videosUrl, "attachment");
      setIsUploading(false);
    } catch (err) {
      alert.error(err.message);
      setIsUploading(false);
    }
  };


  const modalControlFun = (item, type, status) => {
    setMediaUrl(item);
    setMediaType(type);
    setIsModalOpen(status);
  }



  return (
    <>
      <Modal
        contentLabel="Large Modal"
        className="large-modal ticket-modal"
        overlayClassName="custom-modal modal-overlay"
        centered
        show={show}
        onHide={handleClose}
      >
        {uploading ? <Alert variant="info" className="fileupload-status-support">
          Uploading...
        </Alert> : <></>}
        <a class="close message-close text-black" style={styles.modal.close} onClick={() => handleClose()}>×</a>
        <Modal.Body>
          <div className="chat-container">
            <div className="chat" ref={myDivRef}>
              {messages.map((message, index) => (
                <Message
                  key={index}
                  type={message.from == 'admin' ? 'received' : 'sent'}
                  from={message.from == 'admin' ? `Toolsvilla support <${message.adminName}>` : 'You'}
                  content={message.msg}
                  // sl-687
                  mediaRemoved={message?.mediaRemoved}
                  time={message.createdAt}
                  images={message.images}
                  videos={message.videos}
                  docs={message?.docs}
                  modalFun={modalControlFun}
                />
              ))}
            </div>
            <div className="input-box relative suppor-msg-input">
              {/* added file upload icon - 687 */}
              <input type="text" value={msgText} disabled={uploading} onChange={(e) => setMsgText(e.target.value)} placeholder="Type a message..." style={{ paddingRight: "45px" }} />
              {flag === "SellerSupportMsg" ? <></> : <>
                <input type="file" multiple disabled={uploading}
                  accept=".jpg, .jpeg, .png, .mp4, .mov" id="fileInpSeller"
                  style={{ display: "none" }}
                  onClick={(e) => e.target.value = null}
                  onChange={(e) => handleFileChange(e)} />
                <label for="fileInpSeller">
                  <img
                    src="/add-plus.png"
                    alt="send"
                    style={{
                      position: "absolute",
                      right: "77px",
                      width: "32px",
                      height: "31px",
                      bottom: "23%",
                    }}
                  />
                </label>
              </>
              }
              <button disabled={uploading} onClick={() => saveMessage()}>
                <img src="/send.png" alt="send" style={{ width: "80%" }} />
              </button>
            </div>
            {flag === "SellerSupportMsg" ? <></> : <div>
              <p style={styles.text.sizeInfo}><i className="bi bi-info-circle-fill"></i> Image (max. size - 2 Mb) and Video (max. size -25 Mb) can be uploaded.</p>
            </div>}
          </div>
        </Modal.Body>
      </Modal>
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div style={styles.modal.zoom.body} onClick={(e) => e.stopPropagation()}>
            {mediaType === "image" ? (
              <img src={mediaUrl} alt="Modal Content" style={styles.modal.zoom.img} />
            ) : mediaType === "video" ?
              <iframe src={'https://s3.toolsvilla.com/' + mediaUrl} style={styles.modal.zoom.video} /> : <></>
            }
            <button className="close-modal" onClick={() => setIsModalOpen(false)}>
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SupportMessageModal;